import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialGoogleButton } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { currentLocaleSelector, isGoogleEnabledSelector, } from '../../../core/siteConfig/siteConfigSlice.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../core/sourceData/sourceDataSlice.js';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
import { googleAuthUrl } from '../service/index.js';
import { useCurrentUrl } from '../../../../helpers/url/useCurrentUrl.js';
import { clearAuthError } from '../../../core/authError/authErrorSlice.js';
import { rememberMeSelector } from '../../../../views/Login/loginSlice.js';
import { buildGoogleOverwritedRedirectionUrl } from '../buildGoogleOverwritedRedirectionUrl.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector } from '../../../core/wrapperContext/wrapperContextSlice.js';
export const GoogleButton = ({ buttonText }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const currentLocale = useAppSelector(currentLocaleSelector);
    const { trackBtnClick } = useTrack('twoStep');
    const checkboxState = useAppSelector(rememberMeSelector);
    const currentUrl = useCurrentUrl();
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const overwritedRedirectionUrl = buildGoogleOverwritedRedirectionUrl(activeWrapper, redirectionUrl, currentUrl);
    const onGoogleButtonClick = () => {
        dispatch(clearAuthError());
        trackBtnClick({ uniqueName: 'google' });
    };
    const isGoogleEnable = useAppSelector(isGoogleEnabledSelector);
    return isGoogleEnable ? (_jsx(SocialGoogleButton, { "data-testid": "google-register-btn", "data-dd-action-name": "rla_forms_twoStep_googleClick", as: "a", a11yLabel: t('loginregistration.login.googleButton.a11yLabel'), href: googleAuthUrl({
            redirectionUrl: overwritedRedirectionUrl,
            loginSource,
            currentLocale,
            checkboxState,
            currentUrl,
            formType: 'login',
        }), isFullWidth: true, size: ['medium'], onClick: onGoogleButtonClick, children: buttonText || t('loginregistration.login.googleButton') })) : null;
};
//# sourceMappingURL=GoogleButton.js.map